import { ListarsSubCategoriasService } from "../../../Services/Geral/SubCategoria/SubCategoriaServices";
import { Controller } from "../../Controller";

export async function ListarsSubCategoriasController(
    IDProduto: number,
    IDCategoria: number,
    DSCategoria?: string
) {
    return Controller(
        ListarsSubCategoriasService(IDProduto, IDCategoria, DSCategoria)
    );
}
